import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BookingDTO, OrderDTO } from '@lkp/parking-sdk';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-order-items',
    templateUrl: './order-items.component.html',
    styleUrls: ['./order-items.component.scss'],
    standalone: false
})
export class OrderItemsComponent {
  @Input() order?: OrderDTO;
  @Input() currentBooking?: BookingDTO;
  @Input() renderType: 'order' | 'booking' = 'booking';
  readonly onDestroy$ = new Subject<void>();

  constructor(readonly router: Router) {}

  showBooking(id: number | undefined) {
    if (id !== undefined) {
      // open single page view
      this.router.navigate(['bokning', id]);
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    this.order = undefined;
  }
}
